type ResolveHashHrefParams = {
  href: string;
  pathname: string;
  search: string;
};

export default function resolveHashHref({
  href,
  pathname,
  search,
}: ResolveHashHrefParams) {
  if (!href.startsWith('#')) return href;

  const currentPath = pathname.split(/[?#]/, 1)[0] || '/';
  return `${currentPath}${search}${href}`;
}
